import { Api } from "@core/api/api";
import { Page } from "@utils/page";
import { MediaDto, mediaFromDto } from "@domain/media/dtos";
import { Media } from "@domain/media/media";
import { FilterToDto } from "./dto";
import { Filter } from "./filter";

const FILTERS_URL = "/filters";

export class FilterApi {
	constructor(private api: Api) {}

	async fetch(id: string): Promise<Media> {
		const result = await this.api.get<MediaDto>(`${FILTERS_URL}/${id}`);
		return mediaFromDto(result.data);
	}

	async fetchByUserSlug(userSlug: string): Promise<Filter> {
		const result = await this.api.get<FilterToDto>(`${FILTERS_URL}/slug/${userSlug}`);
		return { ...result.data, asset: mediaFromDto(result.data.asset) };
	}

	async list(): Promise<Filter[]> {
		const result = await this.api.get<Page<FilterToDto>>(FILTERS_URL);

		return result.data.content.map((c) => ({ ...c, asset: mediaFromDto(c.asset) }));
	}
}
